const NIF = 'NIF';
const NIE = 'NIE';

export const isNieOrNif = (docNumber: string) => {
  const firstChar: string = docNumber?.charAt(0);
  if (firstChar == 'X' || firstChar == 'Y' || firstChar == 'Z') {
    return 'NIE';
  }
  return 'NIF';
};

const documentType = (type: string): string => {
  const NIF_REGEX = /^(\d{8})([A-Z])$/;
  const NIE_REGEX = /^[XYZ]\d{7,8}[A-Z]$/;

  if (type && type.match(NIF_REGEX)) {
    return NIF;
  }

  if (type && type.match(NIE_REGEX)) {
    return NIE;
  }

  return 'unknown';
};

const validNIF = (nif: string): boolean => {
  const dniLetters = 'TRWAGMYFPDXBNJZSQVHLCKE';
  const letter = dniLetters.charAt(parseInt(nif, 10) % 23);

  return letter == nif.charAt(8);
};

const validNIE = (nie: string): boolean => {
  // Change the initial letter for the corresponding number and validate as NIF
  let niePrefix: number;

  switch (nie.charAt(0)) {
    case 'X':
      niePrefix = 0;
      break;
    case 'Y':
      niePrefix = 1;
      break;
    case 'Z':
      niePrefix = 2;
      break;
  }

  return validNIF(niePrefix + nie.substr(1));
};

// ! DEPRECATED: Remove it and dependecies.
export const validateDocument = (
  document: string,
): { type: string; valid: boolean } => {
  let valid = false;
  const type = documentType(document);

  if (type === NIF) {
    valid = validNIF(document);
  }

  if (type === NIE) {
    valid = validNIE(document);
  }

  return {
    type: type,
    valid: valid,
  };
};

export const passwordRegex =
  /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W]).{8,20})/g;
export const passwordLengthRegexConsumer = /.{6,}/;
export const passwordNumberRegexConsumer = /(?=.*\d)/g;
export const passwordDiversityRegexConsumer =
  /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W])/g;

export const mailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
export const mailRegexConsumer =
  /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*(\+[a-zA-Z0-9-]+)?@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]{2,})*$/g;

// TODO: Move this to .env.con-es
export const zipCodeRegex = /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/;
export const zipCodeCheckoutRegex = /^(?!-)(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/;

// TODO: Telephone regex should be internationalized
export const customRegexName = /^[A-zÀ-ÿẞ \-']+$/gim;

export const directionCharacters = /^(?:[^€\\*;\/#|\$\\"\'+~]*)$/g;
export const directionCharactersItaly = /^(?:[^€\\*;#^|\$\\"\'+~]*)$/g;
export const directionCharactersDeutschland = /^(?:[^€\\*;\#|\$\\"\'+~]*)$/g;

// RUT Tax identification of Chile to AddressFormCl (similar spanish DNI)
export const rutFormat = /^(?:([0-9]){8}[0-9kK]{1})$/;
// ID Identification of Colombia
export const idFormat = /^(?:[0-9]{7,12})$/;
// NIF Identification of Portugal
export const nifFormat = /^(?:[0-9]{9})$/;
//Zip Code of Countries
export const ZipCodeFormatArgentina = /^(?:[0-9]{4})$/;
export const ZipCodeFormatColombia = /^(?:[0-9]{6})$/;
export const zipCodeFormatPeru = /^(?:[0-9]{5})$/;
export const zipCodeFormatMexico = /^(?:[0-9]{5})$/;
export const zipCodeFormatBrazil = /^(?:[0-9]{8})$/;
export const zipCodeFormatPortugal = /^(?:[0-9]{7})$/;
export const zipCodeFormatItaly = /^(?:[0-9]{5})$/;
export const zipCodeFormatDeutschland = /^(?:[0-9]{4,5})$/;
export const zipCodeFormatFrance = /^(?:0[1-9]|[1-8]\d|9[0-8])\d{3}$/;
//Street number validator
export const streetNumberMX = /^[a-zA-Z0-9]{1,5}$/;
export const streetNumberAR = /^\d{1,5}$/;

export const dniPeru = /^(?:[0-9]{8})$/;
export const dniBrasil = /^[a-zA-Z0-9]{11}$/;

export const phoneRegex: Record<string, RegExp> = {
  AR: /^(?:([0-9]){8,11})$/,
  BR: /^(?:([0-9]){8,11})$/,
  CL: /^(?:([0-9]){9})$/,
  CO: /^(?:[36]{1}[0-9]{9})$/,
  DE: /^(?:0?[0-9]{8,15})$/,
  ES: /^(?:[679]{1}[0-9]{8})$/,
  IT: /^(?:([0-9]){8,10})$/,
  MX: /^(?:[2-9]{1}[0-9]{9})$/,
  PE: /^(?:([0-9]){9})$/,
  PT: /^(?:([0-9]){9})$/,
  FR: /^(?:[0-9]{1}[0-9]{8,9})$/,
};

export const genericPhoneRegex = /^(?:([0-9]){6,12})$/;

export const phoneRegexVariable = /^(?:\d*)$/;
// ES: /^(?:[679]{1}[0-9]{0,8})$/,
// CL: /^(?:([0-9]){0,9})$/,
// CO: /^(?:[36]{1}[0-9]{0,9})$/,
// AR: /^(?:(([0-9]){0,11}){8,11})$/,
// PE: /^(?:([0-9]){0,9})$/,
